import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-forgot-password-email',
  templateUrl: './forgot-password-email-sent.page.html',
  styleUrls: ['./forgot-password-email-sent.page.scss'],
})
export class ForgotPasswordEmailSentPage implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
